(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(["exports", "babel-runtime/core-js/object/get-prototype-of", "babel-runtime/helpers/classCallCheck", "babel-runtime/helpers/createClass", "babel-runtime/helpers/possibleConstructorReturn", "babel-runtime/helpers/inherits", "babel-runtime/helpers/taggedTemplateLiteral", "babel-runtime/core-js/object/keys", "babel-runtime/core-js/object/assign", "babel-runtime/core-js/object/values", "react", "./propStyles", "lodash", "styled-components"], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-runtime/core-js/object/get-prototype-of"), require("babel-runtime/helpers/classCallCheck"), require("babel-runtime/helpers/createClass"), require("babel-runtime/helpers/possibleConstructorReturn"), require("babel-runtime/helpers/inherits"), require("babel-runtime/helpers/taggedTemplateLiteral"), require("babel-runtime/core-js/object/keys"), require("babel-runtime/core-js/object/assign"), require("babel-runtime/core-js/object/values"), require("react"), require("./propStyles"), require("lodash"), require("styled-components"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getPrototypeOf, global.classCallCheck, global.createClass, global.possibleConstructorReturn, global.inherits, global.taggedTemplateLiteral, global.keys, global.assign, global.values, global.react, global.propStyles, global.lodash, global.styledComponents);
        global.propStyles = mod.exports;
    }
})(this, function (exports, _getPrototypeOf, _classCallCheck2, _createClass2, _possibleConstructorReturn2, _inherits2, _taggedTemplateLiteral2, _keys, _assign, _values, _react, _propStyles, _lodash, _styledComponents) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.cleanProps = exports.injectStyles = exports.transition = exports.cursor = exports.background = exports.order = exports.overflowY = exports.overflowX = exports.overflow = exports.listStyle = exports.right = exports.left = exports.position = exports.transform = exports.zIndex = exports.outline = exports.filter = exports.wordBreak = exports.textOverflow = exports.textAlign = exports.textTransform = exports.textDecoration = exports.boxShadow = exports.borderStyle = exports.borderColor = exports.borderRadius = exports.borderWidth = exports.justifyContent = exports.alignSelf = exports.alignItems = exports.flexWrap = exports.flexDirection = exports.flex = exports.fill = exports.color = exports.bgColor = exports.iconSize = exports.maxHeight = exports.minHeight = exports.height = exports.maxWidth = exports.minWidth = exports.width = exports.lineHeight = exports.marginY = exports.marginX = exports.margin = exports.paddingY = exports.paddingX = exports.padding = exports.fontStyle = exports.fontWeight = exports.fontSize = exports.fontFamily = exports.display = exports.activated = exports.alternated = exports.selected = exports.focus = exports.active = exports.hover = exports.propStyles = exports.selectorStyle = exports.cssStyle = exports.style = undefined;

    var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

    var _createClass3 = _interopRequireDefault(_createClass2);

    var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

    var _inherits3 = _interopRequireDefault(_inherits2);

    var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

    var _keys2 = _interopRequireDefault(_keys);

    var _assign2 = _interopRequireDefault(_assign);

    var _values2 = _interopRequireDefault(_values);

    var _react2 = _interopRequireDefault(_react);

    var styleFunctions = _interopRequireWildcard(_propStyles);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n        &", " {\n            ", ";\n        }\n    "], ["\n        &", " {\n            ", ";\n        }\n    "]),
        _templateObject2 = (0, _taggedTemplateLiteral3.default)(["\n        ", ";\n    "], ["\n        ", ";\n    "]);

    var style = exports.style = function style(_ref) {
        var key = _ref.key,
            prop = _ref.prop,
            cssProperty = _ref.cssProperty,
            unit = _ref.unit;
        return function (props) {
            // Get value of style prop from props of styled-component
            var propValue = (0, _lodash.get)(props, prop, undefined);

            // If there is no propValue return null
            if (!propValue) return null;

            // If the prop value is an array then generate media query styles
            // It is expected that a theme containing breakpoints is provided to the styled-component
            if ((0, _lodash.isArray)(propValue)) {
                // Get breakpoints from theme
                var breakpoints = (0, _lodash.get)(props, "theme.breakpoints", []);

                // Create media query for each breakpoint with styles within
                var responsiveStyles = (0, _values2.default)(breakpoints).map(function (breakpoint, index) {
                    var value = propValue[index + 1];
                    if (value) {
                        return "@media screen and (min-width: " + breakpoint + ") {\n                            " + cssStyle(props, value, key, prop, cssProperty, unit) + "\n                        }";
                    }
                });

                // Add "default" style for below min-width breakpoint
                responsiveStyles.unshift(cssStyle(props, propValue[0], key, prop, cssProperty, unit));

                return responsiveStyles.join("\n");
            }

            // Else return the style
            return cssStyle(props, propValue, key, prop, cssProperty, unit);
        };
    };

    var cssStyle = exports.cssStyle = function cssStyle(props, propValue, key, prop, cssProperty, unit) {
        // Convert cssProperty to array so we can apply a value to mulitple properties if specfied. E.g: "padding-top, padding-bottom"
        cssProperty = cssProperty.replace(/ /g, "").split(",");

        // Get a value from the theme using key and propValue. E.g: theme.space.xl
        // If this fails because the style function was not provided a key (i.e. not a theme based style),
        // or the propValue does not exist in the theme key then the raw propValue will be used
        var value = (0, _lodash.get)(props, "theme." + key + "." + propValue, propValue);

        // If the value is not a string, apply unit to value if it was provied to the style function
        // Otherwise, if the value is a string the raw propValue will be used.

        // This allows prop styles to be used in a flexible way, for example:
        // fontSize="md" // font-size will be theme.fontSize.md
        // fontSize="inherit" // font-size will be "inherit"
        // fontSize="1em" // font-size will be 1em
        // fontSize={16} // font-size will be 16 units (px) as specified in fontSize style function

        if (!(0, _lodash.isString)(value)) {
            value = unit ? "" + value + unit : value;
        }

        // Return the style
        return cssProperty.map(function (cssProperty) {
            return [cssProperty] + ": " + value + ";";
        }).join("\n");
    };

    // Selector styles work by overwriting current styled-component props with props contained in another prop named after a selector, i.e hover, active, selected etc. The prop name can actually be anything but it's easier to think about if they match up!
    // We then get an array of style functions used, using the prop keys, and return those style functions wrapped in the defined selector.
    // Styled-components' css method will handle the interpolation of style functions from the array.
    // Styles are applied in conjunction with the selector. For example, if the selector is ".active" the component using the active propStyle must set that class name in the DOM.
    // Pseudo classes such as ":hover", ":active" are provided automatically by the browser.
    var selectorStyle = exports.selectorStyle = function selectorStyle(_ref2) {
        var prop = _ref2.prop,
            selector = _ref2.selector;
        return function (props) {
            var selectorStyleProps = (0, _lodash.get)(props, prop, {});
            (0, _assign2.default)(props, selectorStyleProps);
            var selectorStyleFunctions = (0, _keys2.default)(selectorStyleProps).map(function (prop) {
                return (0, _lodash.get)(styleFunctions, prop);
            });
            return (0, _styledComponents.css)(_templateObject, selector, selectorStyleFunctions);
        };
    };

    // Function to return only the prop style functions that are used.
    // Get an array of props, filter all the style functions by that array, then return an array of those functions.
    // NOTE: selectorStyle functions must be called last, otherwise their props will take precedence.
    var propStyles = exports.propStyles = function propStyles(props) {
        var propsArray = (0, _keys2.default)(props);
        var propStyleFunctions = (0, _keys2.default)(styleFunctions).filter(function (fn) {
            return propsArray.includes(fn);
        }).sort(function (a, b) {
            return ["hover", "active", "selected", "activated", "alternated", "focus"].includes(a) ? 1 : -1;
        }).map(function (fn) {
            return (0, _lodash.get)(styleFunctions, fn);
        });
        return (0, _styledComponents.css)(_templateObject2, propStyleFunctions);
    };

    var hover = exports.hover = selectorStyle({ prop: "hover", selector: ":hover" });
    var active = exports.active = selectorStyle({ prop: "active", selector: ":active" });
    var focus = exports.focus = selectorStyle({ prop: "focus", selector: ":focus" });
    var selected = exports.selected = selectorStyle({
        prop: "selected",
        selector: '[data-selected="true"]'
    });
    var alternated = exports.alternated = selectorStyle({
        prop: "alternated",
        selector: '[data-alternated="true"]'
    });
    var activated = exports.activated = selectorStyle({
        prop: "activated",
        selector: ".active"
    });

    var display = exports.display = style({
        prop: "display",
        cssProperty: "display"
    });

    var fontFamily = exports.fontFamily = style({
        prop: "fontFamily",
        key: "fontFamily",
        cssProperty: "font-family"
    });

    var fontSize = exports.fontSize = style({
        prop: "fontSize",
        key: "fontSize",
        cssProperty: "font-size",
        unit: "px"
    });

    var fontWeight = exports.fontWeight = style({
        prop: "fontWeight",
        key: "fontWeight",
        cssProperty: "font-weight"
    });

    var fontStyle = exports.fontStyle = style({
        prop: "fontStyle",
        cssProperty: "font-style"
    });

    var padding = exports.padding = style({
        prop: "padding",
        key: "space",
        cssProperty: "padding",
        unit: "px"
    });

    var paddingX = exports.paddingX = style({
        prop: "paddingX",
        key: "space",
        cssProperty: "padding-left, padding-right",
        unit: "px"
    });

    var paddingY = exports.paddingY = style({
        prop: "paddingY",
        key: "space",
        cssProperty: "padding-top, padding-bottom",
        unit: "px"
    });

    var margin = exports.margin = style({
        prop: "margin",
        key: "space",
        cssProperty: "margin",
        unit: "px"
    });

    var marginX = exports.marginX = style({
        prop: "marginX",
        key: "space",
        cssProperty: "margin-left, margin-right",
        unit: "px"
    });

    var marginY = exports.marginY = style({
        prop: "marginY",
        key: "space",
        cssProperty: "margin-top, margin-bottom",
        unit: "px"
    });

    var lineHeight = exports.lineHeight = style({
        prop: "lineHeight",
        key: "lineHeight",
        cssProperty: "line-height"
    });

    var width = exports.width = style({
        prop: "width",
        cssProperty: "width",
        unit: "px"
    });

    var minWidth = exports.minWidth = style({
        prop: "minWidth",
        cssProperty: "min-width"
    });

    var maxWidth = exports.maxWidth = style({
        prop: "maxWidth",
        cssProperty: "max-width"
    });

    var height = exports.height = style({
        prop: "height",
        cssProperty: "height",
        unit: "px"
    });

    var minHeight = exports.minHeight = style({
        prop: "minHeight",
        cssProperty: "min-height"
    });

    var maxHeight = exports.maxHeight = style({
        prop: "maxHeight",
        cssProperty: "max-height"
    });

    var iconSize = exports.iconSize = style({
        prop: "iconSize",
        key: "iconSize",
        cssProperty: "height, width",
        unit: "px"
    });

    var bgColor = exports.bgColor = style({
        prop: "bgColor",
        key: "color",
        cssProperty: "background-color"
    });

    var color = exports.color = style({
        prop: "color",
        key: "color",
        cssProperty: "color"
    });

    var fill = exports.fill = style({
        prop: "fill",
        key: "color",
        cssProperty: "fill"
    });

    var flex = exports.flex = style({
        prop: "flex",
        cssProperty: "flex"
    });

    var flexDirection = exports.flexDirection = style({
        prop: "flexDirection",
        cssProperty: "flex-direction"
    });

    var flexWrap = exports.flexWrap = style({
        prop: "flexWrap",
        cssProperty: "flex-wrap"
    });

    var alignItems = exports.alignItems = style({
        prop: "alignItems",
        cssProperty: "align-items"
    });

    var alignSelf = exports.alignSelf = style({
        prop: "alignSelf",
        cssProperty: "align-self"
    });

    var justifyContent = exports.justifyContent = style({
        prop: "justifyContent",
        cssProperty: "justify-content"
    });

    var borderWidth = exports.borderWidth = style({
        prop: "borderWidth",
        cssProperty: "border-width",
        unit: "px"
    });

    var borderRadius = exports.borderRadius = style({
        prop: "borderRadius",
        key: "radii",
        cssProperty: "border-radius",
        unit: "px"
    });

    var borderColor = exports.borderColor = style({
        prop: "borderColor",
        key: "color",
        cssProperty: "border-color"
    });

    var borderStyle = exports.borderStyle = style({
        prop: "borderStyle",
        cssProperty: "border-style"
    });

    var boxShadow = exports.boxShadow = style({
        prop: "boxShadow",
        key: "shadow",
        cssProperty: "box-shadow"
    });

    var textDecoration = exports.textDecoration = style({
        prop: "textDecoration",
        cssProperty: "text-decoration"
    });

    var textTransform = exports.textTransform = style({
        prop: "textTransform",
        cssProperty: "text-transform"
    });

    var textAlign = exports.textAlign = style({
        prop: "textAlign",
        cssProperty: "text-align"
    });

    var textOverflow = exports.textOverflow = style({
        prop: "textOverflow",
        cssProperty: "text-overflow"
    });

    var wordBreak = exports.wordBreak = style({
        prop: "wordBreak",
        cssProperty: "word-break"
    });

    var filter = exports.filter = style({
        prop: "filter",
        cssProperty: "filter"
    });

    var outline = exports.outline = style({
        prop: "outline",
        cssProperty: "outline"
    });

    var zIndex = exports.zIndex = style({
        prop: "zIndex",
        key: "zIndex",
        cssProperty: "z-index"
    });

    var transform = exports.transform = style({
        prop: "transform",
        cssProperty: "transform"
    });

    var position = exports.position = style({
        prop: "position",
        cssProperty: "position"
    });

    var left = exports.left = style({
        prop: "left",
        cssProperty: "left"
    });

    var right = exports.right = style({
        prop: "right",
        cssProperty: "right"
    });

    var listStyle = exports.listStyle = style({
        prop: "listStyle",
        cssProperty: "list-style"
    });

    var overflow = exports.overflow = style({
        prop: "overflow",
        cssProperty: "overflow"
    });

    var overflowX = exports.overflowX = style({
        prop: "overflowX",
        cssProperty: "overflow-x"
    });

    var overflowY = exports.overflowY = style({
        prop: "overflowY",
        cssProperty: "overflow-y"
    });

    var order = exports.order = style({
        prop: "order",
        cssProperty: "order"
    });

    var background = exports.background = style({
        prop: "background",
        cssProperty: "background"
    });

    var cursor = exports.cursor = style({
        prop: "cursor",
        cssProperty: "cursor"
    });

    var transition = exports.transition = style({
        prop: "transition",
        cssProperty: "transition"
    });

    var injectStyles = exports.injectStyles = function injectStyles(_ref3) {
        var injectStyles = _ref3.injectStyles;
        return injectStyles;
    };

    // Prevent style props being passed on to the underlying DOM element to avoid unknown prop warnings
    var cleanProps = exports.cleanProps = function cleanProps(Component) {
        return function (_React$Component) {
            (0, _inherits3.default)(Cleaned, _React$Component);

            function Cleaned() {
                (0, _classCallCheck3.default)(this, Cleaned);
                return (0, _possibleConstructorReturn3.default)(this, (Cleaned.__proto__ || (0, _getPrototypeOf2.default)(Cleaned)).apply(this, arguments));
            }

            (0, _createClass3.default)(Cleaned, [{
                key: "render",
                value: function render() {
                    var cleanProps = (0, _lodash.omit)(this.props, (0, _keys2.default)(styleFunctions));
                    return _react2.default.createElement(Component, cleanProps);
                }
            }]);
            return Cleaned;
        }(_react2.default.Component);
    };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-portal-components/build/utils/propStyles.js
// module id = 3
// module chunks = 1